import React from "react";

import styled from "styled-components";
import { Link } from "react-router-dom";

const PageName = styled(Link)``;

export const Brand = ({ brand }) => {
  return (
    <>
      <PageName className="brand">{brand}</PageName>
    </>
  );
};
